import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
// import { AppService } from 'src/app/app.service';
import { AlertsDataService } from "../alerts-data.service";
import { LineItemDelta, LineItemDeltaAlertAPIResponse } from "../alerts.model";
import {
  VAIconRegistryService,
  exclamationTriangle,
} from "@va/core-library/icons";

@Component({
  selector: "app-lid-alert-popover",
  templateUrl: "./lid-alert-popover.component.html",
  styleUrls: ["./lid-alert-popover.component.scss"],
})
export class LidAlertPopoverComponent implements OnInit {
  lidAlertData: LineItemDelta;
  loading = true;
  disabledSaveButton = true;
  faExclamationTriangle = faExclamationTriangle;
  isError = false;
  @Input() ticker: string;
  @Output() onSave: EventEmitter<any> = new EventEmitter();

  constructor(
    private dataService: AlertsDataService,
    private message: NzMessageService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([exclamationTriangle]);
  }

  ngOnInit() {
    this.loading = true;
    this.dataService
      .getLineItemDeltaAlert(this.ticker)
      .subscribe((response: LineItemDeltaAlertAPIResponse) => {
        if (
          response &&
          response.line_item_delta &&
          !response.line_item_delta.is_error
        ) {
          this.lidAlertData = response.line_item_delta;
          this.isError = false;
        } else {
          this.isError = true;
        }
        this.loading = false;
      });
  }

  onLidAlertChange(lidAlert) {
    this.lidAlertData = lidAlert;
    this.disabledSaveButton = false;
  }

  onClickSave() {
    const payload = {
      line_item_delta: this.lidAlertData,
    };
    this.dataService.saveLidAlert(payload, this.ticker).subscribe(
      () => {
        // this.appService.logUserAction(
        //   {},
        //   "",
        //   "",
        //   feature,
        //   {
        //     alert_id: this.alertsDataToSend.alert_id,
        //     action: actionType,
        //     watchlistId: watchlistId
        //   },
        //   "",
        //   actionSource
        // );
        this.message.create("success", `Alert successfully set.`);
        this.onSave.emit();
      },
      () => {
        this.message.create("error", `Error Saving Alert`);
        this.onSave.emit();
      },
    );
  }
}
